{
  "login": {
    "title": "Inicia sesión.",
    "subtitle": "Continúa donde lo dejaste.",
    "email_label": "Correo",
    "password_label": "Contraseña",
    "submit": "Continuar",
    "loading": "Entrando…",
    "forgot_short": "¿Olvidaste?",
    "no_account": "¿No tienes cuenta?",
    "register_link": "Crea una gratis",
    "forgot_link": "¿Olvidaste tu contraseña?",
    "network_error": "No pudimos conectar. Intenta de nuevo en un momento.",
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña",
    "errors": {
      "credentials": "No reconocemos esas credenciales. Revisa el correo y la contraseña.",
      "rate_limit": "Demasiados intentos. Espera un momento e intenta de nuevo.",
      "generic": "Ocurrió un error. Intenta de nuevo.",
      "google": "No pudimos iniciar sesión con Google.",
      "google_generic": "No pudimos completar el inicio con Google. Intenta de nuevo.",
      "apple": "No pudimos iniciar sesión con Apple. Intenta de nuevo.",
      "microsoft": "No pudimos iniciar sesión con Microsoft.",
      "microsoft_no_account": "No existe una cuenta de Tworks con este correo. Regístrate primero y luego vincula Microsoft."
    }
  },
  "register": {
    "title": "Crea tu cuenta.",
    "subtitle": "14 días de Pro gratis. Sin tarjeta.",
    "name_label": "Nombre",
    "email_label": "Correo",
    "password_label": "Contraseña",
    "password_confirmation_label": "Confirmar contraseña",
    "password_hint": "Mínimo 8 caracteres",
    "submit": "Crear cuenta",
    "loading": "Creando…",
    "has_account": "¿Ya tienes cuenta?",
    "login_link": "Inicia sesión",
    "network_error": "No pudimos conectar. Intenta de nuevo en un momento.",
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña",
    "terms": "Al registrarte aceptas nuestros {terms} y {privacy}.",
    "terms_link": "Términos",
    "privacy_link": "Política de privacidad",
    "errors": {
      "generic": "No pudimos crear la cuenta.",
      "google": "No pudimos crear tu cuenta con Google.",
      "google_generic": "No pudimos completar el inicio con Google. Intenta de nuevo.",
      "apple": "No pudimos crear tu cuenta con Apple. Intenta de nuevo."
    },
    "strength_weak": "Débil",
    "strength_fair": "Aceptable",
    "strength_strong": "Fuerte"
  },
  "forgot": {
    "title": "¿Olvidaste tu contraseña?",
    "subtitle": "Te enviamos un link para crear una nueva.",
    "email_label": "Correo",
    "submit": "Enviar link",
    "loading": "Enviando…",
    "success_title": "Listo, revisa tu correo.",
    "success": "Si existe una cuenta con ese correo, te enviamos un link para restablecerla.",
    "network_error": "No pudimos conectar. Intenta de nuevo en un momento.",
    "back_to_login": "Volver al login",
    "errors": {
      "rate_limit": "Demasiados intentos. Espera un momento."
    }
  },
  "reset": {
    "title": "Nueva contraseña.",
    "subtitle": "Elige una que recuerdes esta vez.",
    "password_label": "Nueva contraseña",
    "password_confirmation_label": "Confirmar",
    "submit": "Actualizar contraseña",
    "loading": "Actualizando…",
    "success_title": "Contraseña actualizada.",
    "success_redirect": "Te llevamos al login en un momento…",
    "invalid_link_title": "Link inválido o incompleto",
    "invalid_link_message": "Necesitamos el link completo del correo para continuar.",
    "network_error": "No pudimos conectar. Intenta de nuevo en un momento.",
    "back_to_login": "Volver al login",
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña",
    "errors": {
      "invalid_token": "El link expiró o ya fue usado. Solicita uno nuevo.",
      "rate_limit": "Demasiados intentos. Espera un momento.",
      "generic": "No pudimos restablecer la contraseña."
    }
  },
  "invite_modal": {
    "title": "Invitar al equipo",
    "email_label": "Correo",
    "email_placeholder": "persona{'@'}empresa.com",
    "email_hint": "Si la persona no tiene cuenta, le enviaremos un correo con el enlace para crearla.",
    "seat_notice": "Esta persona ocupará un asiento extra: ${monthly} al mes o ${yearly} al año según tu ciclo, prorrateado.",
    "role_label": "Rol",
    "role_member": "Miembro — puede ver y editar proyectos",
    "role_admin": "Admin — puede gestionar el equipo",
    "role_guest": "Invitado — acceso limitado",
    "submit": "Enviar invitación",
    "loading": "Enviando…",
    "close": "Cerrar",
    "error_generic": "No se pudo procesar la invitación.",
    "error_unexpected": "Error inesperado. Intenta de nuevo."
  },
  "invite": {
    "loading": "Cargando invitación…",
    "brand": "Tworks",
    "go_home": "Ir al inicio",
    "sign_in": "Iniciar sesión",
    "not_available_title": "Invitación no disponible",
    "already_used_title": "Invitación ya utilizada",
    "already_used_message": "Esta invitación ya fue aceptada anteriormente.",
    "expired_title": "Invitación expirada",
    "expired_message": "Esta invitación caducó. Pídele a {inviter} que te envíe una nueva.",
    "pending_title": "Te invitaron a Tworks",
    "pending_message": "{inviter} te invitó a colaborar en {team} como {role}.",
    "different_user_message": "Tienes sesión abierta como {current}, pero esta invitación es para {email}.",
    "logout_and_accept_as": "Cerrar sesión y aceptar como {email}",
    "accept_as_current": "Unirme a {team}",
    "accepting": "Aceptando…",
    "register_email_label": "Correo",
    "register_name_label": "Tu nombre",
    "register_password_label": "Contraseña",
    "register_password_confirm_label": "Confirmar contraseña",
    "register_submit": "Unirme a {team}",
    "register_submitting": "Creando cuenta…",
    "register_disclaimer": "Al crear tu cuenta aceptas unirte al equipo.",
    "expires_on": "Esta invitación expira el {date}.",
    "hero_title": "Colabora con tu equipo sin fricción.",
    "hero_subtitle": "Proyectos, tareas y conversaciones — todo organizado en un solo lugar, en tiempo real.",
    "hero_badge": "Unirte es gratis",
    "errors": {
      "not_found": "Esta invitación no existe o fue eliminada.",
      "load_failed": "No se pudo cargar la invitación.",
      "accept_failed": "No se pudo aceptar la invitación.",
      "register_failed": "No se pudo completar el registro."
    }
  },
  "google": {
    "continue": "Continuar con Google",
    "connecting": "Conectando...",
    "divider": "o"
  }
}
